namespace GeniuzPOS.ReportMasterData {
    export interface Report_1335Form {
    }

    export class Report_1335Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1335';
    }
}
